/**
 * Named z-index scale for the web app.
 *
 * Replaces the raw numeric `zIndex` literals scattered across AppShell and
 * VehicleDetail with a single ordered source of truth. The ordering is the
 * contract (asserted by z-index.test.ts): a dropdown/menu stacks above its
 * outside-click backdrop, which stacks above the fixed mobile tab bar. Values
 * preserve the app's current rendered stacking exactly.
 */
export const Z = {
  /** Fixed mobile bottom tab bar — above page content, below overlays. */
  tabBar: 900,
  /** Full-viewport outside-click layer behind an open menu. */
  backdrop: 999,
  /** Popover menu surface (account menu, vehicle actions overflow). */
  dropdown: 1000,
} as const;
